import { useQuery } from '@tanstack/react-query'
import {
  getDashboardStats,
  type DashboardPeriod,
  type DashboardStats,
} from '@/services/dashboardApi'
import { queryKeys } from '@/lib/queryKeys'
import { useAuthStore } from '@/store/authStore'

/** Una sola cadencia de refresco para todo el dashboard. */
export const DASHBOARD_STATS_REFETCH_MS = 30_000

/**
 * Estadísticas del dashboard vía React Query. Sin `setInterval` propio y sin
 * refrescar en segundo plano: una pestaña oculta no genera peticiones.
 */
export function useDashboardStats(period: DashboardPeriod = 'today') {
  const tenantId = useAuthStore((state) => state.tenantId)

  return useQuery<DashboardStats>({
    queryKey: queryKeys.dashboardStats(tenantId, period),
    queryFn: () => getDashboardStats(period),
    enabled: Boolean(tenantId),
    refetchInterval: DASHBOARD_STATS_REFETCH_MS,
    refetchIntervalInBackground: false,
  })
}
